/* import __COLOCATED_TEMPLATE__ from './resistor-tolerance-error.hbs'; */
import Component from '@glimmer/component';

export default class ResistorToleranceError extends Component {
  get inverting() {
    return this.args.errorHeader === 'inverting';
  }
}
